import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { ErrorMessage } from 'formik';
import classNames from 'classnames';

import ErrorIcon from '../Icons/ErrorIcon/ErrorIcon';
import SuccessIcon from '../Icons/SuccessIcon/SuccessIcon';
import QuestionIcon from 'shared/Icons/QuestionIcon/QuestionIcon';
import HelperText from 'shared/HelperText/HelperText';
import './_FormControl.scss';
import { HelperContent } from 'shared/HelperText/HelperTextInterface';
import Tooltip from 'components/Tooltip/Tooltip';
import { Icon } from 'lmc-ui-library';

interface IFormControl {
  labelText?: string;
  paragraphText?: string;
  error?: boolean;
  errorMessage?: string;
  isCorrect?: boolean;
  helperText?: string;
  helperContent?: HelperContent;
  tooltip?: string;
  noBorder?: boolean;
  required?: boolean;
  hasIcon?: boolean;
  fieldName?: string;
  showErrorIcon?: boolean;
  showSuccessIcon?: boolean;
}

const FormControl: React.FC<IFormControl> = ({
  children,
  labelText = '',
  paragraphText = '',
  error = false,
  errorMessage = undefined,
  isCorrect = false,
  helperText = '',
  helperContent,
  noBorder,
  required,
  hasIcon = false,
  fieldName,
  tooltip,
  showErrorIcon = true,
  showSuccessIcon = true,
}) => {
  const [showHelperText, setShowHelperText] = useState<boolean>(false);
  const hasHelper = Boolean(helperText || helperContent);

  const wrapperClass = classNames('form-control', {
    'form__field-error': error,
    'no-border': noBorder,
    'form-control--with-icon': hasIcon,
  });

  return (
    <div className={wrapperClass}>
      {labelText ? (
        <div className="form-control__label-group">
          <label className="form-control__label">
            {labelText}
            {required && <span className="asterisk">*</span>}
            {tooltip && (
              <span style={{ marginLeft: '4px' }}>
                <Tooltip toolTipText={tooltip}>
                  <Icon type="help" color="#5a0027" />
                </Tooltip>
              </span>
            )}
            {hasHelper && (
              <QuestionIcon setShowHelperText={setShowHelperText} wrapperClassName="form-control--show-helper">
                {showHelperText && (
                  <HelperText helperText={helperText} helperContent={helperContent} showHelperText={showHelperText} />
                )}
              </QuestionIcon>
            )}
          </label>
        </div>
      ) : null}
      <Grid container>
        {!labelText && required && (
          <Grid item md={showErrorIcon ? 7 : 12} sm={12} xs={12}>
            <span className="asterisk">*</span>
          </Grid>
        )}
        {paragraphText && (
          <Grid item md={showErrorIcon ? 7 : 12} sm={12} xs={12}>
            <p className="form-control__paragraph">{paragraphText}</p>
          </Grid>
        )}
      </Grid>
      <Grid container direction="row" justifyContent="center" alignItems="stretch">
        <Grid item sm={showErrorIcon ? 7 : 12} xs={12}>
          <div className="form-control__fields">{children}</div>
        </Grid>
        <Grid container justifyContent="flex-start" alignItems="center" item sm={5} xs={12}>
          <div className="form-control__status-icon">
            {error && showErrorIcon ? <ErrorIcon /> : null}
            {isCorrect && showSuccessIcon ? <SuccessIcon /> : null}
          </div>
        </Grid>
      </Grid>
      {fieldName && <ErrorMessage className="error-message coral" component="div" name={fieldName} />}
      {errorMessage && <p className="error-message coral">{errorMessage}</p>}
    </div>
  );
};

export default FormControl;
